<template>
	<div class="p-settings">
		<div class="container">
			<div class="row">
				<div
					class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1"
				>
					<h3>Stats</h3>
					<p><strong>Version:</strong> v{{ version }}</p>
					<p><strong>Total notes:</strong> {{ notes.length }} Notes</p>
					<hr />
					<b-form @submit.prevent="onSettingsSave">
						<h3>Settings</h3>
						<UserSettings></UserSettings>
						<b-button type="submit" variant="primary">Save</b-button>
						<microNotification
							text="Saved"
							ref="notification"
						></microNotification>
					</b-form>
					<!-- <hr />
					<div>
						<h4>
							Shortkeys
						</h4>
						<p>
							<span class="shortkey">Ctrl</span><span class="shortkey">></span>
						</p>
					</div> -->
					<hr />
					<h4>Send feature requests, bug report, etc.</h4>
					<b-form @submit.prevent="onSubmit">
						<b-form-group id="input-group-1" label-for="input-1">
							<b-form-textarea
								id="input-1"
								v-model="form.content"
								placeholder="Enter something..."
								rows="3"
								max-rows="6"
							></b-form-textarea>
							<!-- <img :src="avatar" /> -->
						</b-form-group>
						<p v-if="error">
							{{ error }}
						</p>
						<b-button
							v-if="form.content.length > 0"
							type="submit"
							variant="primary"
							:class="[{ disabled: lock }]"
							>Send</b-button
						>
					</b-form>
					<br />
					<p>
						This form is the fastest way to get in touch with the developer. Or
						you can also send me an email at shash@underlineme.com
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import microNotification from '@/components/micro-notification.vue';
import UserSettings from '@/components/forms/user-settings';

export default {
	components: {
		microNotification,
		UserSettings,
	},
	data: function () {
		return {
			mode: 'local',
			activationText: '',
			form: {
				content: '',
			},
			toggleOptions: [
				{
					text: 'Closed by default but remembers the state.',
					value: 'default',
				},
				{
					text: 'Always closed by default',
					value: 'close',
				},
				{
					text: 'Always opened by default',
					value: 'open',
				},
			],
			ui: {},
			lock: false,
			error: '',
		};
	},
	watch: {
		mode: function () {
			window.mode = this.mode;
		},
		uiState: {
			handler: function () {
				this.ui = this.uiState;
			},
			immediate: true,
		},
	},
	computed: {
		avatar: function () {
			return this.$store.getters['user/avatar'];
		},
		uiState: function () {
			return this.$store.getters['settings/ui'];
		},
		json: function () {
			var obj = {
				notes: this.notes,
			};
			return JSON.stringify(obj);
		},
		version: function () {
			return this.$store.getters.version;
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
	},
	methods: {
		onBackgroundChange: function (background) {
			this.ui.backgroundImage = background;
		},
		onSettingsSave: function () {
			this.$refs.notification.activate();
			this.$store.dispatch('settings/saveUiState', this.ui);
		},
		onSubmit: function () {
			this.lock = true;
			this.$store.dispatch('ui/sendContact', this.form).then(() => {
				this.lock = false;
				this.error = 'Form sent successfully';
			});
		},
		onBackup: function () {
			this.$store.dispatch('backup');
		},
		onActivate: function () {
			this.$store
				.dispatch('backgroundCheck')
				.then((data) => {
					this.activationText = data.message;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
	mounted: function () {
		this.mode = window.mode || 'local';
	},
};
</script>

<style lang="scss">
.p-settings {
	padding: 1.5rem;

	.shortkey {
		display: inline-block;
		padding: 3px 10px;
		border-radius: 4px;
		background: linear-gradient(
			180deg,
			rgba(255, 255, 255, 0.225) 0%,
			rgba(255, 255, 255, 0.2) 33%,
			rgba(255, 255, 255, 0.15) 100%
		);
		text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2), 0 -1 0 rgba(0, 0, 0, 0.25);
		box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5),
			0 -1px 2px 0 rgba(255, 255, 255, 0.1);
	}

	.contact {
		padding: 1rem;
		background-color: rgba(255, 255, 255, 0.1);
		border-radius: 7px;
		p {
			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.custom-control {
		padding-left: 26px;
		margin-bottom: calc(var(--size-v) * 4);
	}

	.infobox {
		position: relative;
		margin-bottom: 1rem;

		padding: 1rem;
		border-radius: 7px;
		background-color: var(--s3);
		box-shadow: 0 1.8px 3px rgba(0, 0, 0, 0.048),
			0 6px 10.1px rgba(0, 0, 0, 0.072), 0 27px 45px rgba(0, 0, 0, 0.12);

		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: 7px;
			pointer-events: none;
			background: linear-gradient(
				356deg,
				rgba(255, 255, 255, 0.09) 0%,
				rgba(255, 255, 255, 0.15) 70%
			);
		}
	}
}
</style>
